<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0 m-0">
    <ul class="nav nav-tabs nav-tabs-highlight mb-0 skin light-bg" id="qrcodeTabs">
      <!--
  <li class="nav-item" style="border-left-width:0px !important">
    <a @click="enableView" href="#view-qrcode" class="nav-link" v-bind:class="{ 'active show' : viewtype != 'save' }" data-toggle="tab">
      <i class="icon-stack-check"></i>
    </a>
  </li>-->
      <li class="nav-item">
        <a @click="enableSave" v-bind:class="{ 'active show' : viewtype === 'save' }" href="#add-qrcode" class="nav-link" data-toggle="tab">
          <i class="icon-pencil7"></i>
        </a>
      </li>
      <li class="nav-item">
        <a @click="enableSave" v-bind:class="{ 'active show' : viewtype === 'logs' }" href="#qrcode-logs" class="nav-link" data-toggle="tab">
          <i class="icon-database-insert"></i>
        </a>
      </li>
    </ul>
    <div class="tab-content mb-0">
      <!--
  <div v-bind:class="[{ show: viewtype === 'view' }, { active: viewtype === 'view' }]" id="view-qrcode" class="tab-pane fade">
    <view-qrcode ref="vueqrcodeViewRef" v-bind:qrcodeId="qrcodeId"></view-qrcode>
  </div>-->
      <div id="add-qrcode" v-bind:class="[{ show: viewtype === 'save' }, { active: viewtype === 'save' }]" class="tab-pane fade">
        <add-qrcode ref="vueqrcodeSaveRef" @refresh-qr-code="addedQrCode" v-bind:qrcodeId="qrcodeId"></add-qrcode>
      </div>
      <div id="qrcode-logs" v-bind:class="[{ show: viewtype === 'logs' }, { active: viewtype === 'logs' }]" class="tab-pane fade">
        <qrcode-logs ref="vueqrcodeLogsRef" v-bind:qrcodeId="qrcodeId"></qrcode-logs>
      </div>
    </div>
  </div>
</template>


<script>

  import addQRCode from './add-qrcode.vue'
  import viewQRCode from './view-qrcode.vue'

  export default {
    name: "qrcode-container",
    components: {
      addQRCode,
      viewQRCode
    },
    props: {
      qrcodeId: {
        required: false,
        type: Number,
        default: -1
      },
      viewtype: {
        required: false,
        type: String,
        default: 'save'
      },
      onsave: {
        required: false,
        type: String,
        default: ''
      },
    },
    data() {
      return {
      };
    },
    computed: {
    },

    methods: {
      enableView() {
        this.activateTab("view-qrcode");
      },
      enableSave() {
        this.activateTab("add-qrcode");
      },
      activateTab(id) {
        $('#qrcodeTabs a[href="#' + id + '"]').tab('show');
      },
      addedQrCode(param) {
        if (this.onsave != null) {
          eval(this.onsave + "(param)")
        }
      },
    },
    mounted() {

    },
    created: function () {
      if (this.viewtype === "save") {
        this.enableSave();
      }
    },
    watch: {
      qrcodeId: function (newVal, oldVal) {

        if (newVal > 0) {
          //this.viewtype = 'view';
          //this.$refs.vueqrcodeViewRef.qrcodeId = newVal;
          this.$refs.vueqrcodeSaveRef.qrcodeId = newVal;
          this.$refs.vueqrcodeLogsRef.qrcodeId = newVal;

        } else {
          this.viewtype = 'save';
          this.$refs.vueqrcodeSaveRef.resetForm();
        }
      },
      viewtype: function (newVal, oldVal) {
        //alert(newVal);
        //alert("old" + oldVal);
        //if (newVal === "save") {
        //  this.enableSave();
        //}
      }

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/qrcode/qrcode-container.vue